import JSONStream from 'JSONStream';
import XLSX from 'xlsx';

export const handleDataStream = async (response, onStreamEnd) => {
  const rows = [];
  const stream = JSONStream.parse();
  stream.on('data', (data) => {
    rows.push(data);
  });
  stream.on('error', (e) => {
    stream.destroy(e);
    onStreamEnd(rows);
  });
  stream.on('end', () => onStreamEnd(rows));

  try {
    response
      .then((reader) => reader.body.getReader())
      .then((reader) => {
        const decoder = new TextDecoder();
        reader
          .read()
          .then(function process({ done, value }) {
            if (done) {
              return;
            }
            stream.write(decoder.decode(value));
            return reader.read().then(process);
          })
          .then(() => onStreamEnd(rows))
          .catch((e) => {
            console.log('Handle Stream Error', e);
          });
      })
      .catch((e) => {
        console.log('Handle Reader Error', e);
      });
  } catch (e) {
    console.log('Generic Error', e);
  }
};

export const convertJsonToCSV = (data, filename) => {
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(data), 'Sheet1');
  return XLSX.writeFile(wb, filename, { bookType: 'csv' });
};
